import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    totalCount: 0,
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    },
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item.toString(),
        label: LANGUAGE[item]
      };
    })
  },
  getters: {
    projectList: state =>
      state.projects.map(item => ({
        ...item,
        __problem: item.problem.find(item => item.language === 1).content,
        __status: STATUS_TYPES[item.batchStatus]
      }))
  },
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    updateEnabled(context, data) {
      return api.updateEnabled(data);
    }
  }
};

appStore.registerModule('votingStrategy', store);
